import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import Home from './inicio/home';


function App() {
  // Asegurar que la página siempre inicie desde el top
  useEffect(() => {
    // Forzar scroll al top inmediatamente
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);

  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inicio" element={<Home />} />
          <Route path="/productos" element={<Home />} />
          <Route path="/clientes" element={<Home />} />
          <Route path="/Socios" element={<Home />} />
          <Route path="/trabajo" element={<Home />} />
          <Route path="/contacto" element={<Home />} />
          <Route path="/politica" element={<Home />} />
          <Route path="/recetario" element={<Home />} />
          <Route path="/instalaciones" element={<Home />} />
        </Routes> 
      </Router>
  );
}

export default App;